<template>
	<div :style="{
		 
	 }" style="width: 100%;height: 100%;position: relative;" v-if="selectdItem.preStyle.selfStyle">
		<div>
			<div style="height: 10px;width: 100%;"></div>
			<div class="linktit" @click="openCart" style="display: flex;align-items: center;" :style="{
				...getBorder(),
				...getBorderRadius(),
				...getBg(selectdItem),
				...getPadding(selectdItem),
				'--hover': compontentStyle.hoverColor
			}">
				<i style="cursor: pointer;" class="el-icon-goods"></i>
				
				<div v-if="getHtml(selectdItem.preStyle.selfStyle.data.text.list) != ''"
					style="margin-left: 10px;font-family: ;" :style="{
					fontSize:selectdItem.preStyle.selfStyle.titSize + 'px',
					color:selectdItem.preStyle.selfStyle.titColor,
					fontFamily:selectdItem.preStyle.selfStyle.titFontFamily,
				}">
					{{getHtml(selectdItem.preStyle.selfStyle.data.text.list)}}
				</div>
				
				<div style="position: relative;">
					<div class="notranslate" :style="{
							backgroundColor: selectdItem.preStyle.selfStyle.iconNumBgColor,
							color: selectdItem.preStyle.selfStyle.iconNumFrontColor,
							right:'-17px',
							top:  '-17px'
						}" style="position: absolute;width: 16px;height: 16px;border-radius: 100%;z-index: 10;display: flex;align-items: center;justify-content: center;font-size: 9px;">
						{{cartNum > 98?'99+':cartNum}}
					</div>
				</div>
				<!-- <div v-if="cartNum > 0 && type != 'design' && showNum" style="position: relative;">
					<div :style="{
							backgroundColor: selectdItem.preStyle.selfStyle.iconNumBgColor,
							color: selectdItem.preStyle.selfStyle.iconNumFrontColor,
							right:'-17px',
							top:  '-17px'
						}" style="position: absolute;width: 16px;height: 16px;border-radius: 100%;z-index: 100;display: flex;align-items: center;justify-content: center;font-size: 9px;">
						{{cartNum > 98?'99+':cartNum}}
					</div>
				</div> -->
			</div>
			<div style="height: 10px;width: 100%;"></div>
		</div>
		<el-drawer style="height: 100vh;z-index: 1000000;" :size="equipment == 'pc'?'22%':'70%'" append-to-body
			:title="getTit()" :visible.sync="drawer" :before-close="handleClose">
			<div style="position: relative;height: 100%;" v-loading="loading">
				<div v-if="cart.carts && cart.carts.length == 0"
					style="display: flex;justify-content: center;flex-direction: column;align-items: center;">
					<i style="font-size: 38px;margin-top: 20px;" class="el-icon-shopping-cart-2"></i>
					<div :style="{
						 fontSize:equipment == 'pc'?'18px':'14px'
					 }" style="font-size: 18px;font-weight: bold;margin-top: 20px;">{{getTit2()}}</div>
					<div :style="{
					 	fontSize:equipment == 'pc'?'16px':'12px'
					 }" style="font-size: 16px;font-weight: bold;margin-top: 20px;color: #b4b4b4 ;">{{getTit3()}}</div>
					<div style="margin-top: 20px;">
						<el-button style="background-color: black;color: #fff;border: 1px;"
							@click="navTo">{{getTit4()}}</el-button>
					</div>
				</div>
				<div style="width: 100%;position: absolute;overflow-y: scroll;height: calc(100% - 226px);">
					<div v-if="cart.carts && cart.carts.length != 0"
						style="display: flex;justify-content: center;flex-direction: column;align-items: center;width: 100%;">
						<div style="display: flex;align-items: center;justify-content: space-around;margin-top: 20px;width: 100%;"
							v-for="(item,index) in cart.carts" :key="index">
							<div @click="selectItem(item)" :style="{
									width: equipment == 'pc'?'60px':'28px'
								}" style="display: flex;justify-content: center;align-items: center;">
								<div v-if="item.selected != 0" :style="{
									height: equipment == 'pc'?'20px':'14px',
									width: equipment == 'pc'?'20px':'14px'
								 }" style="width: 20px;height: 20px;border: 1px #797979 solid;border-radius: 100%;display: flex;justify-content: center;align-items: center;background-color: #635bff;color: #fff;cursor: pointer;">
									<i class="el-icon-check"></i>
								</div>
								<div v-if="item.selected == 0" :style="{
									height: equipment == 'pc'?'20px':'14px',
									width: equipment == 'pc'?'20px':'14px'
								 }" style="border: 1px #797979 solid;border-radius: 100%;display: flex;justify-content: center;align-items: center;color: #fff;cursor: pointer;">
								</div>
							</div>
							<div :style="{
									width:equipment == 'pc'?'calc(100% - 60px)':'calc(100% - 38px)'
								}" style="display: flex;align-items: center;width: calc(100% - 60px);">
								<div :style="{
									height: equipment == 'pc'?'78px':'38px',
									width: equipment == 'pc'?'78px':'38px'
								 }">
									<img :style="{
									 	height: equipment == 'pc'?'78px':'38px',
									 	width: equipment == 'pc'?'78px':'38px'
									 }" :src="item.image_url" />
								</div>
								<div :style="{
										height:equipment == 'pc'?'80px':'60px'
									}" style="display: flex;flex-direction: column;justify-content: space-between;margin-left: 10px;font-size: 12px;width: 100%;">
									<div>
										{{item.name}}
									</div>
									<div
										style="display: flex;justify-content: space-between;align-items: center;width: 100%;">
										<div style="display: flex;align-items: center;">
											<div>{{item.subtotal_format}} x </div>
											<div style="margin-left: 10px;"><input @blur="changeGoods(item)"
													v-model="item.quantity"
													style="width: 50px;height: 24px;padding: 0px;text-indent:0px" />
											</div>
										</div>
										<div :style="{
											 fontSize:equipment == 'pc'?'20px':'14px'
										 }" @click="delGoods(item)" style="cursor: pointer;margin-right: 20px;"><i class="el-icon-delete"></i></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="cart.carts&& cart.carts.length != 0 "
					style="position: absolute;bottom: 0px;width: 100%;left: 0px;background-color: #fff;height: 226px;">
					<div
						style="width: 100%;display: flex;justify-content:space-between;height: 66px;background-color: #f8f9fa;align-items: center;">
						<div>
							<div style="display: flex;align-items: center;"
								v-if="cart.quantity == cart.quantity_all && cart.quantity != 0">
								<div @click="selectItems" style="width: 40px;display: flex;justify-content: flex-end;">
									<div :style="{
										height: equipment == 'pc'?'20px':'14px',
										width: equipment == 'pc'?'20px':'14px'
									 }" style="border: 1px #797979 solid;border-radius: 100%;display: flex;justify-content: center;align-items: center;background-color: #635bff;color: #fff;cursor: pointer;">
										<i class="el-icon-check"></i>
									</div>
								</div>
								<div :style="{
							fontSize:equipment == 'pc'?'14px':'12px'
						}" style="margin-left: 10px;color: #8f8f8f;">{{getTit8()}}</div>
							</div>
							<div @click="selectItems" style="width: 60px;display: flex;justify-content: center;">
								<div v-if="cart.quantity_all != 0?cart.quantity != cart.quantity_all :false" :style="{
									height: equipment == 'pc'?'20px':'14px',
									width: equipment == 'pc'?'20px':'14px'
								 }" style="border: 1px #797979 solid;border-radius: 100%;display: flex;justify-content: center;align-items: center;color: #fff;cursor: pointer;">
								</div>
							</div>
						</div>
						<div :style="{
							fontSize:equipment == 'pc'?'16px':'12px'
						}" style="margin-right: 20px;font-size: 16px;color: #8f8f8f;">
							<div>{{getTit7()}} <span style="font-weight: bold;color: #000;"> ( {{cart.quantity}} )
									{{cart.amount_format}}</span></div>
							<div></div>
						</div>
					</div>
					<div
						style="margin-top: 30px;display: flex;flex-direction: column;align-items: center;margin-bottom: 30px;width: 100%;">
						<div v-if="cart.quantity != 0" style="width: 100%;display: flex;justify-content: center;">
							<el-button :style="{
								width:equipment == 'pc'?'350px':'90%'
							}" @click="goCheckOut" class="btn" style="background-color: #000;color: #fff;">{{getTit5()}}</el-button>
						</div>
						<div style="margin-top: 20px;width: 100%;display: flex;justify-content: center;">
							<el-button @click="goCarts" class="btn1" :style="{
								width:equipment == 'pc'?'350px':'90%'
							}" style="background-color: #ffffff;color: #000000 ;border: solid 1px #000000 ;font-weight: bold;">{{getTit6()}}</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>
<script>
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import {
		getCartsData,
		getCartsSelect,
		getCartsUnselect,
		getCartsCartId,
		getCartsCartIdDel,
		getCartsMini
	} from '../../api/all.js'
	export default {
		props: {
			all_setting: {
				type: Array,
				default: () => {
					return []
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				showNum:true,
				num: 0,
				loading: false,
				cart: {},
				drawer: false,
			}
		},
		watch: {
			$route: {
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					if(this.cartNum == 0) {
						this.getCartNum()
					}
				}
			},
			selectdItem:{
				immediate: true,
				deep: true,
				handler: function(newVal, oldVal) {
					if (!newVal.preStyle.selfStyle.iconNumShow === undefined) {
						this.$set(newVal.preStyle.selfStyle, 'iconNumShow', true)
					}
					if (!newVal.preStyle.selfStyle.iconNumBgColor) {
						this.$set(newVal.preStyle.selfStyle, 'iconNumBgColor', '#ff5500')
					}
					if(!newVal.preStyle.selfStyle.iconNumFrontColor){
						this.$set(newVal.preStyle.selfStyle,'iconNumFrontColor','#fff')
					}
				}
			}
		},
		computed: {
			fontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			},
			...mapState("lowCodeStore", ['cartNum']),
		},
		
		
		
		async mounted() {
			

			if (!this.selectdItem.preStyle.selfStyle.titFontFamily) {
				this.$set(this.selectdItem.preStyle.selfStyle, 'titFontFamily', this.fontFamilyName)
			}

			if (!this.selectdItem.preStyle.selfStyle.titColor) {
				this.$set(this.selectdItem.preStyle.selfStyle, 'titColor', '#000')
			}

			if (!this.selectdItem.preStyle.selfStyle.titSize) {
				this.$set(this.selectdItem.preStyle.selfStyle, 'titSize', 14)
			}

			// let data = await getCartsData()
			// console.log('data', data)
			// this.cart = data.data.data
			// console.log('cart',this.cart)
			// this.cart = {
			// 	"carts": [{
			// 			"cart_id": 34,
			// 			"product_id": 6,
			// 			"sku_id": 274,
			// 			"sku": "sku274",
			// 			"product_sku": "sku274",
			// 			"name": "冰丝褶皱垂感圆领长袖T恤男宽松薄款高级感v领男装上衣",
			// 			"name_format": "冰丝褶皱垂感圆领长袖T恤男宽松薄...",
			// 			"image": "catalog/demo/product/7.jpg",
			// 			"image_url": "https://www.ggyykk111.shop/cache/catalog/demo/product/7-100x100.jpg",
			// 			"quantity": 1,
			// 			"selected": 1,
			// 			"price": 423,
			// 			"shipping": 1,
			// 			"price_format": "￥423.00",
			// 			"tax_class_id": 1,
			// 			"subtotal": 423,
			// 			"subtotal_format": "￥423.00",
			// 			"variant_labels": ""
			// 		},
			// 		{
			// 			"cart_id": 33,
			// 			"product_id": 5,
			// 			"sku_id": 273,
			// 			"sku": "sku273",
			// 			"product_sku": "sku273",
			// 			"name": "高级感男装夏季潮牌美式复古短袖t恤男士重磅纯棉宽松半袖男体恤",
			// 			"name_format": "高级感男装夏季潮牌美式复古短袖t...",
			// 			"image": "catalog/demo/product/4.jpg",
			// 			"image_url": "https://www.ggyykk111.shop/cache/catalog/demo/product/4-100x100.jpg",
			// 			"quantity": 1,
			// 			"selected": 1,
			// 			"price": 999,
			// 			"shipping": 1,
			// 			"price_format": "￥999.00",
			// 			"tax_class_id": 1,
			// 			"subtotal": 999,
			// 			"subtotal_format": "￥999.00",
			// 			"variant_labels": ""
			// 		}
			// 	],
			// 	"quantity": 2,
			// 	"quantity_all": 2,
			// 	"amount": 1422,
			// 	"amount_format": "￥1,422.00"
			// }

		},
		methods: {
			...mapMutations("lowCodeStore", ["setSelectdItem", "setCenterList", "setList"]),
			async getCartNum(){
				let data = await getCartsMini()
				// data.data.num
				console.log('datadata',data)
				this.setList({
					filed:"cartNum",
					list:data.data.data.num,
				})
				this.showNum = false
				this.$nextTick(()=>{
					this.showNum = true
				})
				
			},
			goCheckOut() {
				this.drawer = false
				this.$router.push({
					path: '/checkout'
				})
			},
			goCarts() {
				this.drawer = false
				this.$router.push({
					path: '/carts'
				})
			},
			getPadding(e) {
				let style = {
					paddingTop: e.preStyle.selfStyle.padding[0] + 'px',
					paddingBottom: e.preStyle.selfStyle.padding[2] + 'px',
					paddingLeft: e.preStyle.selfStyle.padding[1] + 'px',
					paddingRight: e.preStyle.selfStyle.padding[3] + 'px'
				}
				return style
			},
			cssStringToObject(cssString) {
				const styleObject = {};

				// 移除所有注释（可选）
				const cleanedCss = cssString.replace(/\/\*[\s\S]*?\*\//g, '');

				// 分割每条规则
				const rules = cleanedCss.split(';').filter(rule => rule.trim() !== '');

				rules.forEach(rule => {
					const [property, value] = rule.split(':').map(item => item.trim());
					if (property && value) {
						// 转换属性名为驼峰式（如 background-color -> backgroundColor）
						const camelCaseProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
						styleObject[camelCaseProperty] = value;
					}
				});

				return styleObject;
			},
			getBg(e) {
				let style = {}
				if (e.preStyle.selfStyle.bg.color && e.preStyle.selfStyle.bg.bgtype == 'color') {
					style.background = e.preStyle.selfStyle.bg.color
				}
				if (e.preStyle.selfStyle.bg.bgtype && e.preStyle.selfStyle.bg.bgtype == 'img') {
					if (e.preStyle.selfStyle.bg.img) {

						let backgroundImage = `url(${e.preStyle.selfStyle.bg.img})`

						if (e.preStyle.selfStyle.bg.bgImgWidth) {
							style.backgroundSize = e.preStyle.selfStyle.bg.bgImgWidth + 'px';
						} else {
							style.backgroundSize = '100%';
						}
						if (e.preStyle.selfStyle.bg.bgImgHeigth) {
							style.backgroundSize = style.backgroundSize + ' ' + (e.preStyle.selfStyle.bg.bgImgHeigth +
								'px')
						} else {
							style.backgroundSize = style.backgroundSize + ' 100%'
						}
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
						if (e.preStyle.selfStyle.bg.position) {
							style.backgroundPosition = e.preStyle.selfStyle.bg.position
						}
						style.backgroundImage = backgroundImage
						if (e.preStyle.selfStyle.bg.type) {
							style.backgroundRepeat = e.preStyle.selfStyle.bg.type
						}
					}
				}
				if (e.preStyle.selfStyle.bg.bgtype == 'gradient') {
					style = {
						...style,
						...this.cssStringToObject(e.preStyle.selfStyle.bg.bgGradient)
					}
				}

				return style
			},


			getBorderRadius() {
				let style = {}
				style.borderRadius =
					`${this.selectdItem.preStyle.selfStyle.border.borderRadius[0]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[1]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[2]}px ${this.selectdItem.preStyle.selfStyle.border.borderRadius[3]}px`
				console.log('getBorderRadius', style)
				return style
			},
			getBorder() {
				if (this.selectdItem.preStyle.selfStyle.border.type && this.selectdItem.preStyle.selfStyle.border.color) {
					let style = {}
					style.borderTop =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[0]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderLeft =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[1]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderBottom =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[2]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					style.borderRight =
						`${this.selectdItem.preStyle.selfStyle.border.type} ${this.selectdItem.preStyle.selfStyle.border.borderSize[3]}px ${this.selectdItem.preStyle.selfStyle.border.color}`
					return style
				}
			},


			getHtml(list) {
				console.log('systemConfigsystemConfigsystemConfig', this.systemConfig)
				let text = ''
				for (let i = 0; i < list.length; i++) {
					if (this.systemConfig.locale == list[i].language) {
						if (list[i].text != '') {
							text = list[i].text
						}
					}
				}
				return text
			},
			getTit5() {
				let obj = {
					'zh_cn': '去结账',
					'en': 'Checkout',
					'zh_hk': '去結賬',
					'ja': 'チェックアウトに行きます',
					'ko': '계산하러 가기',
					'de': 'Zur Kasse gehen',
					'es': 'ir a la caja',
					'fr': 'aller à la caisse',
					'id': 'Pergi ke checkout',
					'it': 'vai alla cassa',
					'ru': 'перейти к оформлению заказа',
				}
				return obj[this.systemConfig.locale]
			},
			getTit6() {
				let obj = {
					'zh_cn': '查看购物车',
					'en': 'Shopping Cart',
					'zh_hk': '查看購物車',
					'ja': 'ショッピングカートを確認する',
					'ko': '장바구니 보기',
					'de': 'Warenkorb prüfen',
					'es': 'revisa el carrito de compras',
					'fr': 'vérifier le panier',
					'id': 'Lihat Keranjang',
					'it': 'controlla il carrello',
					'ru': 'проверить корзину',
				}
				return obj[this.systemConfig.locale]
			},
			getTit7() {
				let obj = {
					'zh_cn': '商品总计',
					'en': 'Product Total',
					'zh_hk': '商品總計',
					'ja': '商品合計',
					'ko': '상품총계',
					'de': 'Produktsumme',
					'es': 'total del producto',
					'fr': 'Produit total',
					'id': 'Total Barang Dagangan',
					'it': 'Totale del prodotto',
					'ru': 'Всего продукта',
				}
				return obj[this.systemConfig.locale]
			},
			getTit8() {
				let obj = {
					'zh_cn': '全选',
					'en': 'Product Total',
					'zh_hk': '全選',
					'ja': 'すべて選択',
					'ko': '모두 선택',
					'de': 'alle auswählen',
					'es': 'seleccionar todo',
					'fr': 'tout sélectionner',
					'id': 'Pilih Semua',
					'it': 'seleziona tutto',
					'ru': 'выбрать все',
				}
				return obj[this.systemConfig.locale]
			},
			getTit4() {
				let obj = {
					'zh_cn': '去逛逛',
					'en': 'Go Shopping',
					'zh_hk': '去逛逛',
					'ja': '買い物に行く',
					'ko': '구경하러 가기',
					'de': 'Einkaufen gehen',
					'es': 'ir de compras',
					'fr': 'aller faire les courses',
					'id': 'Pergi berbelanja',
					'it': 'Andare a fare shopping',
					'ru': 'ходить по магазинам',
				}
				return obj[this.systemConfig.locale]
			},
			async delGoods(e) {
				this.loading = true
				let data;
				data = await getCartsCartIdDel({
					cart_id: e.cart_id,
				})
				this.cart = data.data.data
				this.loading = false
				this.setList({
					filed:"cartNum",
					list:this.cart.carts.length,
				})
				// console.log('this.cart', this.cart.carts.length)
			},
			async changeGoods(e) {
				this.loading = true
				console.log('e', e)
				let num = parseInt(e.quantity)
				if (!num) {
					e.quantity = 1
					return
				}
				e.quantity = num
				console.log('num', num)
				let data;
				data = await getCartsCartId({
					cart_id: e.cart_id,
					sku_id: e.sku_id,
					quantity: num
				})
				console.log('data', data)
				this.cart = data.data.data;
				this.loading = false
			},
			async selectItem(e) {
				this.loading = true
				let data
				if (e.selected) {
					data = await getCartsUnselect({
						cart_ids: [e.cart_id]
					})
				} else {
					data = await getCartsSelect({
						cart_ids: [e.cart_id]
					})

				}
				this.cart = data.data.data
				this.loading = false
				console.log(data)
				console.log('this.cart', this.cart)
			},
			async selectItems() {
				this.loading = true
				let cart_ids = []
				let data
				this.cart.carts.forEach(item => {
					cart_ids.push(item.cart_id)
				})
				if (this.cart.quantity == this.cart.quantity_all) {
					data = await getCartsUnselect({
						cart_ids: cart_ids
					})
				} else {
					data = await getCartsSelect({
						cart_ids: cart_ids
					})
				}
				this.cart = data.data.data
				console.log('this.cart ', this.cart)
				this.loading = false
			},
			navTo() {
				this.drawer = false
				this.$router.push('/')
			},
			getTit2() {
				let obj = {
					'zh_cn': '您的购物车是空的',
					'en': 'Your shopping cart is empty',
					'zh_hk': '您的購物車是空的',
					'ja': 'ショッピングカートは空です',
					'ko': '장바구니가 비어 있습니다',
					'de': 'Ihr Warenkorb ist leer',
					'es': 'Su cesta está vacía',
					'fr': 'Votre panier est vide',
					'id': 'Keranjang Anda kosong',
					'it': 'Il tuo carrello è vuoto',
					'ru': 'Ваша корзина пуста',
				}
				return obj[this.systemConfig.locale]

			},
			getTit3() {
				let obj = {
					'zh_cn': '您可以去看看有哪些想买的',
					'en': 'You can go and see what you want to buy',
					'zh_hk': '您可以去看看有哪些想買的',
					'ja': '買いたいものを見に行くことができる',
					'ko': '사고 싶은 상품 보러 가기',
					'de': 'Sie können gehen und sehen, was Sie kaufen möchten',
					'es': 'Puedes ir y ver lo que quieres comprar.',
					'fr': 'Vous pouvez aller voir ce que vous voulez acheter',
					'id': 'Anda bisa pergi dan melihat apa yang ingin Anda beli',
					'it': 'Puoi andare a vedere cosa vuoi comprare',
					'ru': 'Вы можете пойти и посмотреть, что вы хотите купить',
				}
				return obj[this.systemConfig.locale]
			},
			getTit() {
				console.log('this.systemConfig.locale', this.systemConfig.locale)
				let obj = {
					'zh_cn': '您的购物车',
					'en': 'Your cart',
					'zh_hk': '您的購物車',
					'ja': 'あなたのカート',
					'ko': '당신의 장바구니',
					'de': 'Ihr Warenkorb',
					'es': 'tu carrito',
					'fr': 'votre panier',
					'id': 'Keranjang belanja Anda',
					'it': 'Il tuo carrello',
					'ru': 'ваша корзина',
				}
				return obj[this.systemConfig.locale]
			},
			async handleClose() {
				this.drawer = false

			},
			async openCart() {

				if (this.type == 'design') {
					return
				}
				if (this.equipment == 'phone') {
					// this.$router.push({
					// 	path:'/carts'
					// })
					this.drawer = true
				}
				if (this.equipment != 'phone') {
					this.drawer = true
				}
				this.$nextTick(async () => {
					this.loading = true
					let data = await getCartsData()
					this.cart = data.data.data
					console.log('this.cart', this.cart)
					// this.cart = {
					// 	"carts": [{
					// 			"cart_id": 34,
					// 			"product_id": 6,
					// 			"sku_id": 274,
					// 			"sku": "sku274",
					// 			"product_sku": "sku274",
					// 			"name": "冰丝褶皱垂感圆领长袖T恤男宽松薄款高级感v领男装上衣",
					// 			"name_format": "冰丝褶皱垂感圆领长袖T恤男宽松薄...",
					// 			"image": "catalog/demo/product/7.jpg",
					// 			"image_url": "https://www.ggyykk111.shop/cache/catalog/demo/product/7-100x100.jpg",
					// 			"quantity": 1,
					// 			"selected": 1,
					// 			"price": 423,
					// 			"shipping": 1,
					// 			"price_format": "￥423.00",
					// 			"tax_class_id": 1,
					// 			"subtotal": 423,
					// 			"subtotal_format": "￥423.00",
					// 			"variant_labels": ""
					// 		},
					// 		{
					// 			"cart_id": 33,
					// 			"product_id": 5,
					// 			"sku_id": 273,
					// 			"sku": "sku273",
					// 			"product_sku": "sku273",
					// 			"name": "高级感男装夏季潮牌美式复古短袖t恤男士重磅纯棉宽松半袖男体恤",
					// 			"name_format": "高级感男装夏季潮牌美式复古短袖t...",
					// 			"image": "catalog/demo/product/4.jpg",
					// 			"image_url": "https://www.ggyykk111.shop/cache/catalog/demo/product/4-100x100.jpg",
					// 			"quantity": 1,
					// 			"selected": 1,
					// 			"price": 999,
					// 			"shipping": 1,
					// 			"price_format": "￥999.00",
					// 			"tax_class_id": 1,
					// 			"subtotal": 999,
					// 			"subtotal_format": "￥999.00",
					// 			"variant_labels": ""
					// 		}
					// 	],
					// 	"quantity": 2,
					// 	"quantity_all": 2,
					// 	"amount": 1422,
					// 	"amount_format": "￥1,422.00"
					// }


					this.loading = false
				})
			}
		}
	}
</script>

<style scoped>
	.btn:hover {
		background-color: #353535;
	}

	.btn1:hover {
		background-color: #000000;
		color: #fff;
	}

	.linktit:hover {
		cursor: pointer;
		color: var(--hover);
	}
</style>